import { render } from "./HomePage.vue?vue&type=template&id=53bd9d18"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\documenti\\Lavoro\\Niemit\\com.niemit.cortebenedetto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__